var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5276 5.64325V5.25511C15.5276 4.86574 15.4245 4.48322 15.2285 4.14601C15.0325 3.8088 14.7506 3.52877 14.4112 3.33408L9.11458 0.297151C8.77515 0.102485 8.39011 0 7.99816 0C7.60622 0 7.22118 0.102485 6.88174 0.297151L1.58517 3.33492C1.2457 3.5296 0.963815 3.80963 0.767841 4.14684C0.571866 4.48406 0.468711 4.86657 0.46875 5.25594V5.77689L1.18019 6.12178V5.48024C1.18015 5.14663 1.26855 4.81888 1.43651 4.52999C1.60446 4.24109 1.84605 4.00122 2.13696 3.83451L6.84853 1.13249V2.43166L2.31419 5.03332V11.1105L6.84853 13.7111V15.0102L2.13696 12.3088C1.84602 12.1419 1.60443 11.902 1.43648 11.613C1.26853 11.324 1.18013 10.9962 1.18019 10.6625V7.045L0.46875 6.70011V10.8865C0.468711 11.2759 0.571866 11.6584 0.767841 11.9956C0.963815 12.3328 1.2457 12.6128 1.58517 12.8075L6.87588 15.8414C6.98387 15.9033 7.09682 15.9561 7.2136 15.9994V0.922613L7.51727 0.748502C7.66702 0.662527 7.83691 0.617205 8.00988 0.617089H8.01324C8.2011 0.617225 8.38504 0.670502 8.54353 0.770683L8.78245 0.922613V16C8.89952 15.9571 9.01268 15.9043 9.12072 15.8422L14.4109 12.8084C14.7503 12.6137 15.0322 12.3337 15.2282 11.9964C15.4242 11.6592 15.5273 11.2767 15.5273 10.8873V6.5698L14.8159 6.92246V10.6614C14.8159 10.995 14.7276 11.3228 14.5597 11.6117C14.3919 11.9007 14.1504 12.1407 13.8596 12.3077L9.14807 15.0097V13.7111L13.6819 11.1094V5.03332L9.14807 2.43221V1.13249L13.8594 3.83451C14.1501 4.00133 14.3916 4.24124 14.5594 4.53012C14.7273 4.81901 14.8156 5.14669 14.8156 5.48024V5.99563L15.5276 5.64325ZM6.84741 9.29873L3.04461 7.05083V5.45334L6.84741 3.27254V9.29873ZM10.9528 7.9125L11.8054 8.41653L12.9498 9.09301V10.6891L9.14751 12.8699V6.84456L10.9528 7.9125Z",
    fill: "url(#paint0_linear_215_5407)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_215_5407",
    x1: 7.99802,
    y1: -0.667319,
    x2: 7.99802,
    y2: 16.6469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.9f900a52fac72a869260694ebec8d453.svg";
export { ForwardRef as ReactComponent };